import React, { PureComponent } from 'react'
import {
  string, func, shape, instanceOf,
} from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import CreateAccountDetail from './components/CreateAccount'
import { ageValidatorBuilder } from '../../shared/validator'
import { calculateAge, filterDate } from '../../shared/utils/commonUtils'
import { CreateAccountFormDefaultTypes, CreateAccountFormPropTypes } from './components/CreateAccount/CreateAccountForm'

const ADULT_AGE = 18

class SignupDetail extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    configureTrack: func.isRequired,

    fields: shape({
      email: string,
      firstName: string,
      lastName: string,
      dob: instanceOf(Date),
      countryCode: string,
    }),

    ...CreateAccountFormPropTypes,
  }

  static defaultProps = {
    fields: {},
    ...CreateAccountFormDefaultTypes,
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'SignupDetail',
      widget: 'signup_detail',
      pageType: 'signup detail',
    })
  }

  render() {
    const {
      i18n, fields,
      // CreateAccountForm
      firstNameField, lastNameField, dobField, countryField, emailField, passwordField,
    } = this.props
    const {
      firstName, lastName, dob, countryCode, email,
    } = fields
    const adultDOBValidator = ageValidatorBuilder({
      min: { value: ADULT_AGE, errMsg: i18n('passport.error.validation.youngAge', { 0: ADULT_AGE }) },
    })

    const initDob = filterDate(dobField.value) || filterDate(dob) || new Date()
    return (
      <CreateAccountDetail
        {...this.props}
        firstNameField={{ hidden: firstName && lastName, ...firstNameField }}
        lastNameField={{ hidden: firstName && lastName, ...lastNameField }}
        dobField={{
          customerValidator: adultDOBValidator,
          hidden: calculateAge(initDob) >= 18,
          ...dobField,
          // Extract init dob from Component to Widget
          value: initDob,
        }}
        countryField={{ hidden: countryCode, ...countryField }}
        emailField={{ changeAble: !email, ...emailField }}
        passwordField={passwordField}
        hasSignInLink
          // USER-5726 Do not support amEighteen except CUISingup
        amEighteen={false}
      />
    )
  }
}

export default withI18n(SignupDetail)
